import { makeStyles } from '@material-ui/core';

const styles = makeStyles(({ spacing }: any) => ({
  container: {
    width: '100%',
    height: '100vh',
  },
  header: {
    marginBottom: spacing(4),
  },
  infoAlert: {
    marginTop: spacing(4),
  },
  textField: {
    marginTop: spacing(5),
    marginBottom: spacing(3),
  },
  submitButton: {
    marginTop: spacing(10),
  },
}));

export default styles;
